<template>
  <div class="more-photo">
    <p class="photo-title">{{title}}</p>
    <div class="img_list" v-if="isShowImgList">
        <div class="file" v-for="(item, index) in displayImgList" :key="index" @click="openFile(item)">
            <img class="success-icon" src="@/assets/pc/success-filled.png" />
            <span>{{ getFileName(item) }}</span>
            <img class="close-icon" src="@/assets/pc/file-cancel-icon.png" @click.stop="removeList(index)" />
        </div>
        <div v-if="imgList.length > 10 && !isShowMoreFile" class="show-more" @click="showMorefile">Show More ({{imgList.length - 10}})</div>
    </div>
    <div :class="['photo_box', isShowImgList && 'none']">
      <el-upload
        v-if="!isShowImg"
        :id="'fileUploadId'+uploadNumber"
        class="upload-content"
        action=""
        accept=".jpg,.jpeg,.png,.pdf"
        :multiple="true"
        :show-file-list="false"
        :http-request="(e) => uploadImgSuccess(e, 'multiple', onceUploadNumber, exceedNumber, imgList)"
        :before-upload="beforeImgUpload"
      >
        <div class="photo-content top" @click="clearOnceUploadTime">
            <p><img src="@/assets/pc/upload-outline@2x.png" />Upload File</p>
        </div>
      </el-upload>
    </div>
    <div class="list-content">
      <span class="num">{{imgListLength}} out of {{exceedNumber}}</span>
      <div v-if="imgListLength !== 0 && imgListLength < exceedNumber" class="photo-btn add" @click="clearOnceUploadTime">
          <span @click="add" :class="addStyle">{{`+ Add Another ${fieldName}`}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MorePhotoUpload",
    components: {},
    props: {
      img:{
        type: [String, Array],
        default: () => []
      },
      title:{
        type: String,
        default: ""
      },
      // 当前页面上传组件脚标
      uploadNumber: {
        type: Number,
        default: 0
      },
      // 字段名称
      fieldName: {
        type: String,
        default: "File"
      },
      // 单次最大上传数 5
      onceUploadNumber: {
        type: Number,
        default: 5
      },
      // 最大上传文件数
      exceedNumber: {
        type: Number,
        default: 5
      },
    },
    data() {
      return {
        imgData: '',
        imgList: [],
        addStyle: "",
        showDialog: false,
        pdfSrc: '',
        onceUploadTime: 0,
        uploadingNumber: 0,
        isShowMoreFile: false,
      }
    },
    computed: {
      // 判断展示图片还是空白
      isShowImg() {
        return this.imgData !== ""
      },
      // 判断图片列表长度
      isShowImgList() {
        return this.imgList.length > 0
      },
      // 获取图片列表长度
      imgListLength() {
        return this.imgList.length
      },
      imgDataChange() {
        return this.imgData + this.imgList.length
      },
      displayImgList() {
        return this.isShowMoreFile ? this.imgList : this.imgList.slice(0, 10);
      }
    },
    methods: {
      showMorefile() {
        this.isShowMoreFile = true;
      },
      clearOnceUploadTime() {
        this.onceUploadTime = 0;
      },
      // 删除图片
      remove() {
        this.imgData = ""
      },
      removeList(index) {
        let arr = [...this.imgList];
        arr.splice(index, 1)
        this.imgList = arr
      },
      add() {
        if (this.addStyle === "disable") {
          return
        }
        let arr = [...this.imgList]
        if (this.imgData == "") {
            const element = document.querySelector(`#fileUploadId${this.uploadNumber} .el-upload__input`);
            element && element.click();
        } else {
          this.$refs && this.$refs.pdfRef && this.$refs.pdfRef.destroyWorker && this.$refs.pdfRef.destroyWorker();
          arr.push(this.imgData)
          this.imgList = arr
          this.imgData = ""
        }
      },
      showPdf(src) {
        this.pdfSrc = src
        this.showDialog = true;
      },
      closeDialog() {
        this.showDialog = false;
      },
    },
    watch: {
      imgListLength:function(val) {
        if (val >= this.exceedNumber) {
          this.addStyle = "disable"
        } else {
          this.addStyle = ""
        }
      },
      imgDataChange:function() {
        let data = [...this.imgList];
        if (this.imgData) {
          data.push(this.imgData)
        }
        this.$emit("imgData", data)
      },
      img:function(val) {
        let data = [];
        if(Array.isArray(val)) {
          data = [...val];
        } else {
          data = val ? val.split(',') : [];
        }
        if(data.length > 0) {
          this.imgList = data
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .more-photo {
    & > div {
      font-size: 0;
    }
    .img_list {
      margin-bottom: 24px;
      width: 366px;
      .img_box {
        img {
          width: 366px;
          height: 228px;
          border-radius: 8px;
          display: block;
        }
        .pdf-view{
          cursor: pointer;
          height: 228px;
          overflow: auto;
          >div{
            height: 100%;
          }
        }
      }
      .file {
        width: 100%;
        display: flex;
        font: normal normal normal 14px/24px Nunito-bold;
        background-color: #F6F6F6;
        padding: 12px 16px 12px 12px;
        align-items: center;
        color: #2E2E2E;
        border-radius: 6px;
        box-sizing: border-box;
        cursor: pointer;
        word-break: break-word;
        margin-bottom: 8px;
        .success-icon {
          width: 40px;
          height: 40px;
          margin-right: 16px;
        }
        span {
          flex: 1;
        }
        .close-icon {
          width: 30px;
          height: 30px;
          margin-left: 10px;
        }
      }
      .show-more {
        border-radius: 6px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font: normal normal normal 14px/24px Nunito-bold;
        color: #0072D8;
        cursor: pointer;
        margin-bottom: 8px;
        background-color: #E5F1FF;
        padding: 8px 0;
        box-sizing: border-box;
      }
    }
    .photo-title {
      font: normal normal normal 16px/22px Nunito;
      margin: 0 0 16px;
      color: #2E2E2E;
    }
    .photo_box {
      width: 366px;
      height: 216px;
      background-color: #E5F5FF;
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 24px;
      &.none {
        display: none;
      }
      & > div {
        text-align: center;
      }
      .upload-content{
        margin-top: 89px;
      }
      .photo-content {
        margin-top: 16px;
        &.top {
          margin-top: 0;
        }
        p {
          margin: 0 auto;
          width: 195px;
          color: #0072D8;
          font: normal normal normal 16px/48px Nunito-bold;
          border-radius: 8px;
          border: 2px solid #0072D8;
          img {
            width: 32px;
            height: 32px;
            vertical-align: middle;
            margin-right: 8px;
            margin-top: -5px;
          }
        }
      }
      .pdf-view{
        cursor: pointer;
        height: 100%;
        overflow: auto;
        >div{
          height: 100%;
        }
      }
    }
    .img {
      width: 366px;
      height: 228px;
      border-radius: 8px;
      display: block;
    }
    .photo-btn {
      width: 366px;
      height: 22px;
      overflow: hidden;
      span {
        float: right;
        font: normal normal normal 16px/22px Nunito;
        color: #0072D8;
        cursor: pointer;
      }
    }
    .add {
      margin: 4px 0 16px;
      padding-right: 20px; 
      width: 100%;
      text-align: right;
      box-sizing: border-box;
      span {
        text-decoration: underline;
        font: normal normal normal 16px/24px Nunito-bold;
      }
      .disable {
        color: #919191;
      }
    }
    .list-content{
      display: flex;
      justify-content: space-between;
      margin: 4px 0 16px;
      .num{
        margin: 4px 0 16px;
        width: 50%;
        font-size: 16px;
        color: #656565;
      }
    }
  }
</style>